import {useCallback, useRef} from 'react';

import {useUnmount} from './useUnmount';

/**
 * This hook allows you to block the next calls of the function execution until time ends
 * For example, you can use it to prevent double click on a button
 */
export const useTimeBlockedCallback = <T extends (...args: any[]) => void>(
  fn?: T,
  timeBlocked = 500,
) => {
  const isBlockedRef = useRef(false);
  const timeout = useRef(0);

  const callback = useCallback(
    (...args: Parameters<T>) => {
      if (!isBlockedRef.current) {
        fn?.(...args);
      }

      timeout.current = +setTimeout(() => {
        isBlockedRef.current = false;
      }, timeBlocked);

      isBlockedRef.current = true;
    },
    [fn, timeBlocked],
  );

  useUnmount(() => clearTimeout(timeout.current));

  return callback;
};
